




































# import settings from '@/settings'
import t from '@/utils/tools'

export default {
    name: 'capacitations'

    props: ['payload', 'deletions']

    watch:
        payload: (new_item, old_item)->
            # console.log "WATCH ", new_item, old_item
            if Object.keys(@payload).length == 0
                @add_capacitation()

    data: ()->
        true: true
        false: false
        capacitation: {
            uid: ''
            name: ''
            skill_type: 'capacitation'
            slug: ''
            level_waited: 1
            mandatory: false
        }

    methods:
        deep_copy: t.deep_copy

        remove_capacitation: (index)->
            if @payload[index]['uid'] != ""
                @deletions.push(@payload[index]['uid'])
            # console.log "DELETIONS C : ", @deletions
            if Object.keys(@payload).length > 1
                @payload.splice(index, 1)
            else
                @payload[0].name = ""
                @payload[0].mandatory = false
                # console.log "FIRST CAPACITATION"

        add_capacitation: ()->
            @payload.push(@deep_copy(@capacitation))
        
    beforeMount: ()->
        # console.log "CAPACITATIONS COMPONENT : ", @payload
        if Object.keys(@payload).length == 0
            @add_capacitation()
}
